import React, { useEffect, useState, useCallback } from "react";
import Cookies from "js-cookie";
import { URL, ImgURL } from "../url/api";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import axioswToken from "../api/axios";
import { getSessionToken } from "../utils/auth";

// import axios from "axios";
import {
  removeItemToCart,
  reduceItemToCart,
  addProducts,
  refreshCart,
} from "../reduxSetup/slices/productsSlice";
import almond from "../asset/pngImage/almond.png";

const Cart = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const data = useSelector((state) => state.product.data);
  const dispatch = useDispatch();
  // const [data, setData] = useState([]);
  const [countData, setCountData] = useState("");
  const [storeMinAmount, setStoreMinAmount] = useState();
  const [, setToken] = useState("");
  const [addressData, setAddressData] = useState([]);
  const [addressSet, setAddressSet] = useState(false);
  const [add_Address, setAdd_Address] = useState(false);
  const [update_Address, setUpdate_Address] = useState(false);
  const [name, setName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [alterNumber, setAlterNumber] = useState("");
  const [houseNumber, setHouseNumber] = useState("");
  const [city, setCity] = useState("");
  const [locality, setLocality] = useState("");
  const [zip, setZip] = useState("");
  const [state, setState] = useState("");
  const [addressId, setAddressID] = useState(null);
  // useEffect(()=>{
  //   getCartDataforUpdate();
  // }, []);
  // Runs once on mount to fetch the server cart. Must NOT depend on `data` —
  // getCartDataforUpdate dispatches refreshCart, which changes `data`, which
  // would re-trigger this effect and loop forever, hammering /getCart until
  // the shared api-wide rate limit (429) kicks in. Resyncing after a mutation
  // is handled explicitly by updateCart()'s own success callback instead.
  useEffect(() => {
    checkLogin();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- run once on mount only; checkLogin chains into getCartDataforUpdate, which would loop forever if re-triggered every render (see comment above)
  }, []);

  const Total_price = useCallback(() => {
    if (data && data.length) {
      const sum_SP = data.reduce((total, item) => total + (item?.variant?.sp || 0) * (item?.qty || 0), 0);
      setCountData(sum_SP);
    }
  }, [data]);

  useEffect(() => {
    Total_price();
  }, [Total_price]);

  //show toast
  const showToast = (title) => {
    toast.success(title, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  };
  const isValidMobile = (num) => /^[6-9]\d{9}$/.test(num);

  const showToastErr = (title) => {
    toast.error(title, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  };

  //use all input field handle
  const nameInputChange = (e) => {
    setName(e.target.value);
  };
  const phoneInputChange = (e) => {
    const inputPhoneNumber = e.target.value;

    // Only update the state if the input length is less than or equal to 10
    if (inputPhoneNumber.length <= 10) {
      setPhoneNumber(inputPhoneNumber);
    }
  };
  const alterNumberInputChange = (e) => {
    const inputAlterNumber = e.target.value;
    if (inputAlterNumber.length <= 10) {
      setAlterNumber(inputAlterNumber);
    }
  };
  const houseInputChange = (e) => {
    setHouseNumber(e.target.value);
  };
  const nearInputChange = (e) => {
    setLocality(e.target.value);
  };
  const cityInputChange = (e) => {
    setCity(e.target.value);
  };
  const zipInputChange = (e) => {
    const inputPhoneNumber = e.target.value;

    // Only update the state if the input length is less than or equal to 10
    if (inputPhoneNumber.length <= 6) {
      setZip(inputPhoneNumber);
    }
  };
  const stateInputChange = (e) => {
    setState(e.target.value);
  };
  // this is use to check login to user login or not
  const checkLogin = () => {
    try {
      const session = getSessionToken();
      if (session !== undefined && session !== null) {
        const token = JSON.parse(session);
        setToken(token);
        getCartDataforUpdate();
      }
    } catch (error) {
      // There was an error on the native side
    }
  };
  // this is use to increment and decrement data to get cart data.
  // Also resyncs Redux cart items from the server's authoritative cart
  // so a rejected update (stock changed etc.) can't leave stale qty on screen.
  const getCartDataforUpdate = async () => {
    try {
      const response = await axioswToken.get(`${URL}/getCart`);
      const newData = await response.data;
      setStoreMinAmount(newData);
      newData?.data?.cart?.forEach((item) => dispatch(refreshCart(item)));
    } catch (error) {
      console.error("Fetch cart failed", error);
    }
  };
  
  // this function  use to increment items quantity
  function Increment(item) {
    const variantID = item.variant_id;
    const newCount = item.qty + 1;
    updateCart(variantID, newCount, () => dispatch(addProducts(item)));
  }
  // this function  use to Decrement items quantity
  function Decrement(item, index) {
    const variantID = item.variant_id;
    if (item.qty >= 1) {
      const newCount = item.qty - 1;
      updateCart(variantID, newCount, () => {
        if (item.qty > 1) dispatch(reduceItemToCart(item));
        else dispatch(removeItemToCart(index));
      });
    }
  }
  // this is use to increment and decrement data to update cart.
  // Redux is only updated once the server confirms the change, so a failed
  // request (out of stock, network error) never leaves the displayed cart
  // out of sync with what checkout will actually charge.
  const updateCart = async (variantID, newCount, onSuccess) => {
    var formdata = new FormData();
    formdata.append("variant_id", JSON.stringify(variantID));
    formdata.append("qty", newCount);

    try {
      const response = await axioswToken.post(`${URL}/updateCart`, formdata);
      if (response.data?.error === false) {
        onSuccess?.();
        getCartDataforUpdate();
      } else {
        showToastErr(response.data?.msg || "Unable to update cart.");
      }
    } catch (error) {
      console.error("Update cart failed", error);
      showToastErr("Unable to update cart. Please try again.");
    }
  };
  // Get user Address
  const getCustomerAddresses = async () => {
    try {
      const response = await axioswToken.get(`${URL}/getCustomerAddresses`);
      const userData = await response.data;
      const addresses = userData?.data || [];
      setAddressData(addresses);
      setAddressID(addresses[0]?.id);
      if (addresses[0]) Cookies.set("user_address", JSON.stringify(addresses[0]));
    } catch (error) {
      console.error("Fetch addresses failed", error);
      setAddressData([]);
    }
  };

  const handleImageError = (event) => {
    event.target.src = almond;
  };
  // Add  New Customer Address
  const addCustomerAddress = async () => {
    if (!houseNumber || !locality || !city || !state || !zip || !name || !phoneNumber) {
      showToastErr("Please fill in all required fields.");
      return;
    }
    if (!isValidMobile(phoneNumber)) {
      showToastErr("Please enter a valid 10-digit mobile number.");
      return;
    }
    if (alterNumber && !isValidMobile(alterNumber)) {
      showToastErr("Please enter a valid 10-digit alternate number.");
      return;
    }
    // var myHeaders = new Headers();
    // myHeaders.append("Authorization", `Bearer ${Token}`);

    var formdata = new FormData();
    formdata.append("house_no", houseNumber);
    formdata.append("locality", locality);
    formdata.append("city", city);
    formdata.append("state", state);
    formdata.append("pincode", zip);
    formdata.append("contact_person", name);
    formdata.append("contact_no", phoneNumber);
    formdata.append("alter_number", alterNumber);

    // var requestOptions = {
    //   method: "POST",
    //   headers: myHeaders,
    //   body: formdata,
    //   redirect: "follow",
    // };

    try {
      const response = await axioswToken.post(`${URL}/addCustomerAddress`, formdata);
      const userData = await response.data;
      const changeData = (userData?.msg || "").replace(/[{}[\]]/g, "");
      if (userData.error === false) {
        getCustomerAddresses();
        handaleInput();
        setAdd_Address(false);
        setAddressSet(true);
        showToast(changeData || "Address saved.");
      } else {
        showToastErr(changeData || "Unable to save address.");
      }
    } catch (error) {
      console.error("Add address failed", error);
      showToastErr("Unable to save address. Please try again.");
    }
  };
  const handaleInput = () => {
    setName("");
    setPhoneNumber("");
    setAlterNumber("");
    setHouseNumber("");
    setLocality("");
    setCity("");
    setState("");
    setZip("");
  };

  // Update Customer Address
  const updateCustomerAddress = async () => {
    if (!houseNumber || !locality || !city || !state || !zip || !name || !phoneNumber) {
      showToastErr("Please fill in all required fields.");
      return;
    }
    if (!isValidMobile(phoneNumber)) {
      showToastErr("Please enter a valid 10-digit mobile number.");
      return;
    }
    if (alterNumber && !isValidMobile(alterNumber)) {
      showToastErr("Please enter a valid 10-digit alternate number.");
      return;
    }
    // var myHeaders = new Headers();
    // myHeaders.append("Authorization", `Bearer ${Token}`);

    let formdata = new FormData();
    formdata.append("id", addressId);
    formdata.append("house_no", houseNumber);
    formdata.append("locality", locality);
    formdata.append("city", city);
    formdata.append("state", state);
    formdata.append("pincode", zip);
    formdata.append("contact_person", name);
    formdata.append("contact_no", phoneNumber);
    formdata.append("alter_number", alterNumber);

    // var requestOptions = {
    //   method: "POST",
    //   headers: myHeaders,
    //   body: formdata,
    //   redirect: "follow",
    // };

    try {
      const response = await axioswToken.post(`${URL}/updateCustomerAddress`, formdata);
      const userData = await response.data;
      const changeData = (userData?.msg || "").replace(/[{}[\]]/g, "");
      if (userData.error === false) {
        getCustomerAddresses();
        setAdd_Address(false);
        setAddressSet(true);
        setUpdate_Address(false);
        setAddressID(null);
        handaleInput();
        showToast(changeData || "Address updated.");
      } else {
        showToastErr(changeData || "Unable to update address.");
      }
    } catch (error) {
      console.error("Update address failed", error);
      showToastErr("Unable to update address. Please try again.");
    }
  };
  return (
    <>
      {/* Backdrop */}
      <div
        className={`cart-backdrop${isOpen ? " cart-backdrop--open" : ""}`}
        onClick={onClose}
      />
      {/* Panel */}
      <div
        className={`cart-panel${isOpen ? " cart-panel--open" : ""}`}
        tabIndex="-1"
        id="offcanvasWithBackdrop"
        aria-labelledby="offcanvasWithBackdropLabel"
      >
      {add_Address === false ? (
        <>
          {addressSet === false ? (
            <>
              {/* ── My Cart ── */}
              <div className="cart-header">
                <div className="cart-header-left">
                  <i className="fa-solid fa-cart-shopping"></i>
                  <h5 className="cart-title" id="offcanvasWithBackdropLabel">My Cart</h5>
                </div>
                <button type="button" className="cart-close" onClick={onClose} aria-label="Close">
                  <i className="fa-solid fa-xmark"></i>
                </button>
              </div>

              <div className="cart-body">
                {data?.length === 0 || !data ? (
                  <div className="cart-empty">
                    <i className="fa-solid fa-bag-shopping"></i>
                    <p>Your cart is empty</p>
                    <a href="/" className="cart-empty-link btn btn-primary px-4" onClick={onClose} style={{ textDecoration: "none", borderRadius: "18px" }}>
                      <p>Continue Shopping</p>
                    </a>
                  </div>
                ) : (
                  data?.filter((item) => item?.product && item?.variant).map((item, index) => (
                    <div key={index} className="cart-item">
                      <div className="cart-item-img-wrap">
                        <img
                          key={item.id}
                          alt={item?.product?.name}
                          loading="lazy"
                          onError={handleImageError}
                          src={(!item.product.img || item.product.img === 'null') ? almond : `${ImgURL}${item.product.img}`}
                          className="cart-item-img"
                        />
                      </div>
                      <div className="cart-item-info">
                        <p className="cart-item-name">{item.product.name}</p>
                        <p className="cart-item-size">{item.variant.size}</p>
                        <div className="cart-item-price">
                          {item.variant.mrp !== item.variant.sp && (
                            <del className="cart-item-mrp">₹{item.variant.mrp}</del>
                          )}
                          <span className="cart-item-sp">₹{item.variant.sp}</span>
                        </div>
                      </div>
                      <div className="cart-qty">
                        <button
                          type="button"
                          className="cart-qty-btn"
                          onClick={() => Decrement(item, index)}
                        >−</button>
                        <span className="cart-qty-count">{item.qty}</span>
                        <button
                          type="button"
                          className="cart-qty-btn"
                          onClick={() => Increment(item)}
                        >+</button>
                      </div>
                    </div>
                  ))
                )}
              </div>

              {data && data.length > 0 && (
                <div className="cart-footer" onClick={() => {
                  if (storeMinAmount?.data?.min_order > countData) {
                    showToastErr(`Minimum order should be ${storeMinAmount?.data?.min_order} Rs.`);
                  } else {
                    setAddressSet(true);
                    getCustomerAddresses();
                  }
                }}>
                  <div className="cart-footer-total">
                    <span className="cart-footer-label">Total</span>
                    <span className="cart-footer-amount">₹{countData}</span>
                  </div>
                  <button type="button" className="cart-proceed-btn">
                    Proceed to Pay <i className="fa-solid fa-arrow-right"></i>
                  </button>
                </div>
              )}
            </>
          ) : (
            <>
              {/* ── My Address ── */}
              <div className="cart-header">
                <div className="cart-header-left">
                  <i className="fa-solid fa-location-dot"></i>
                  <h5 className="cart-title" id="offcanvasScrollingLabel">My Address</h5>
                </div>
                <button type="button" className="cart-close" aria-label="Close"
                  onClick={() => { setAddressSet(false); handaleInput(); }}>
                  <i className="fa-solid fa-xmark"></i>
                </button>
              </div>

              <div className="cart-addr-add-wrap">
                <button type="button" className="cart-add-addr-btn"
                  onClick={() => { setAdd_Address(true); setAddressSet(false); handaleInput(); }}>
                  <i className="fa-solid fa-plus"></i> Add New Address
                </button>
              </div>

              <div className="cart-body">
                {addressData.length === 0 && (
                  <div className="cart-empty">
                    <i className="fa-solid fa-location-dot"></i>
                    <p>No saved addresses</p>
                  </div>
                )}
                {addressData.map((item) => (
                  <div
                    key={item.id}
                    className={`cart-addr-card ${item.id === addressId ? "cart-addr-card--active" : ""}`}
                    onClick={() => { setAddressID(item.id); Cookies.set("user_address", JSON.stringify(item)); }}
                  >
                    {item.id === addressId && (
                      <span className="cart-addr-check"><i className="fa-solid fa-circle-check"></i></span>
                    )}
                    <p className="cart-addr-name">{item.contact_person}</p>
                    <p className="cart-addr-phone">{item.contact_no}</p>
                    {item.house_no && item.locality && item?.city && item.pincode && item.state && (
                      <p className="cart-addr-line">
                        {item.house_no}, {item.locality}, {item.city}, {item.pincode}, {item.state}
                      </p>
                    )}
                  </div>
                ))}
              </div>

              <div className="cart-footer">
                <div className="my-nav-link cart-footer-link">
                  <button
                    type="button"
                    className="cart-proceed-btn cart-proceed-btn--full"
                    onClick={(e) => { 
                      e.stopPropagation(); 
                      setAddressSet(false); 
                      onClose(); 
                      if (addressId) navigate(`/checkout/${addressId}`); 
                    }}
                  >
                    Confirm Address <i className="fa-solid fa-arrow-right"></i>
                  </button>
                </div>
              </div>
            </>
          )}
        </>
      ) : (
        <>
          {/* ── Add / Update Address ── */}
          <div className="cart-header">
            <div className="cart-header-left">
              <i className="fa-solid fa-map-pin"></i>
              <h5 className="cart-title" id="offcanvasScrollingLabel">
                {update_Address ? "Update Address" : "Add Address"}
              </h5>
            </div>
            <button type="button" className="cart-close" aria-label="Close"
              onClick={() => {
                setAdd_Address(false);
                setAddressSet(true);
                if (update_Address) setUpdate_Address(false);
                handaleInput();
              }}>
              <i className="fa-solid fa-xmark"></i>
            </button>
          </div>

          <div className="cart-body">
            <div className="cart-form">
              <input type="text" defaultValue={name || ""} className="cart-input" placeholder="Full Name" required onChange={nameInputChange} />
              <input type="number" className="cart-input" defaultValue={phoneNumber || ""} placeholder="Phone Number" required onChange={phoneInputChange}
                onKeyPress={(e) => { if (e.target.value.length >= 10) e.preventDefault(); }} />
              <input type="number" className="cart-input" defaultValue={alterNumber || ""} placeholder="Alternate Number (optional)" onChange={alterNumberInputChange}
                onKeyPress={(e) => { if (e.target.value.length >= 10) e.preventDefault(); }} />
              <input type="text" className="cart-input" defaultValue={houseNumber || ""} placeholder="House / Flat No." required onChange={houseInputChange} />
              <input type="text" className="cart-input" defaultValue={locality || ""} placeholder="Locality / Near" required onChange={nearInputChange} />
              <input type="text" className="cart-input" defaultValue={city || ""} placeholder="City" required onChange={cityInputChange} />
              <input type="text" className="cart-input" defaultValue={zip || ""} placeholder="PIN Code" required onChange={zipInputChange}
                onKeyPress={(e) => { if (e.target.value.length >= 6) e.preventDefault(); }} />
              <input type="text" className="cart-input" placeholder="State" defaultValue={state || ""} required onChange={stateInputChange} />
            </div>
          </div>

          <div className="cart-footer">
            <button type="button" className="cart-proceed-btn cart-proceed-btn--full"
              onClick={() => { update_Address ? updateCustomerAddress() : addCustomerAddress(); }}>
              {update_Address ? "Update Address" : "Save Address"} <i className="fa-solid fa-check"></i>
            </button>
          </div>
        </>
      )}
      </div>
    </>
  );
};

export default Cart;
